import { useRef, useState } from "react";
import { api, apiError } from "../lib/api";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";

export function FileUpload({ onUploaded, accept = "image/*,application/pdf", label = "Upload file", testId, capture }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const change = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(data);
      toast.success("File uploaded");
    } catch (err) {
      toast.error(apiError(err));
    }
    setBusy(false);
    e.target.value = "";
  };

  return (
    <>
      <input ref={ref} type="file" accept={accept} capture={capture} onChange={change} className="hidden" data-testid={testId} />
      <Button type="button" variant="outline" onClick={() => ref.current?.click()} disabled={busy}
        className="rounded-xl h-11 w-full">
        {busy ? <Loader2 className="animate-spin mr-1.5" size={16} /> : <Upload size={16} className="mr-1.5" />}
        {label}
      </Button>
    </>
  );
}
